export default __webpack_public_path__ + "static/media/errorIcon.d9b40187.svg";